// Qwiksurv brand palette. Mirrors Colors in the mobile apps' Theme.js so the
// panel and the apps stay in step; keep them in sync if either changes.
export const BRAND = {
  primary: '#f46a47',
  primaryActive: '#e05130',
  primaryDark: '#7c2d12',
  primaryLight: '#feece7',
  primaryMuted: '#f9b49f', // disabled and inactive states
  gradient: 'linear-gradient(135deg, #f46a47, #e05130)',
  authGradient: 'linear-gradient(135deg, #7c2d12 0%, #e05130 45%, #f46a47 100%)',
} as const

export const LOGO = {
  icon: '/media/logos/qwiksurv-icon.png',
  appIcon: '/media/logos/qwiksurv-favicon.png',
  wordmark: '/media/logos/qwiksurv-wordmark.png',
} as const
